import React, { useState } from "react"
import PropTypes from "prop-types"
import Button from "@components/Button/Button"
import { directAxiosInstance } from "@lib/api"
import Dialog from "@components/Dialog/Dialog.js"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import { mergeAccountInfo } from "../reducer"
import css from "../Auth.scss"
import { getAssetPath, sanitizer } from "@commonUtils"
import Separator from "@components/Separator/Separator"
const Card = (props) => {
    const { heading, subHeading, imageUrl, index } = props
    return (
        <div className="flex">
            <div className={`${css.cardImage} ${css.marginBoth12}`}>
                {imageUrl && (
                    <ImageLoader
                        src={imageUrl}
                        alt="Image of Step"
                        title="Image of Step"
                        width={index === 2 || index === 4 ? "60px" : "42px"}
                    />
                )}
            </div>
            <div className={`flexColumn ${css.marginLeft16}`}>
                <div className="bodySemiBold">{heading}</div>
                <div className="smallRegular textSecondary">{subHeading}</div>
            </div>
        </div>
    )
}
const MergeAccount = ({ forwardHandler, state, localDispatch }) => {
    const { info, mergeAccountInformation } = state
    const [errMsg, setErrMsg] = useState(null)
    /**
     * @description Function to generate otp to merge user phone number and email
     */

    const [iconUrl, setIconUrl] = useState(null)
    const icon = getAssetPath("svgs/icons/loading-wheel_24px_background.svg")
    const tokenMerge = () => {
        setIconUrl(icon)
        directAxiosInstance()
            .post("auth/email/create_token_merge", {
                number: info.phone,
                email: info.email,
                otp_on_call: false,
            })
            .then((res) => {
                if (res && res.data) {
                    if (res.data.user_flags.is_otp_required) {
                        forwardHandler("TokenMerge")
                        localDispatch(mergeAccountInfo({ flag: false }))
                    }
                }
                setIconUrl(null)
            })
            .catch((err) => {
                setIconUrl(null)
                const errMsg = err?.data?.error?.message || "Server error"
                setErrMsg(errMsg)
            })
    }
    return (
        <>
            <Dialog isOpen={mergeAccountInformation?.flag}>
                <div className={` ${css.mergePopupContainer}  `}>
                    <div className={` flex justifyBetween alignCenter`}>
                        <div className="l3SemiBold">{mergeAccountInformation?.header}</div>
                        <img
                            src={getAssetPath("svgs/icons/cross_18px_primary.svg")}
                            alt={"clear input"}
                            onClick={() => localDispatch(mergeAccountInfo({ flag: false }))}
                        />
                    </div>

                    <div className={"marginTop-16"}>
                        <div className="flex justifyBetween">
                            {mergeAccountInformation?.description && (
                                <div
                                    className={` alignCenter smallRegular textSecondary `}
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizer(mergeAccountInformation?.description),
                                    }}
                                />
                            )}
                            {mergeAccountInformation?.imageUrl && (
                                <ImageLoader
                                    className={css.marginRight16}
                                    src={mergeAccountInformation?.imageUrl}
                                    alt={mergeAccountInformation?.imageAlt}
                                    width="104px"
                                    height="64px"
                                />
                            )}
                        </div>
                    </div>
                    <Separator marginTop="20px" marginBottom="20px" size="xs" />
                    <div className={"flexColumn "}>
                        {mergeAccountInformation?.heading && (
                            <div className={` l3SemiBold marginTop-8 textPrimary`}>
                                {mergeAccountInformation?.heading}
                            </div>
                        )}

                        {mergeAccountInformation?.steps &&
                            mergeAccountInformation?.steps.length > 0 &&
                            mergeAccountInformation?.steps.map((step, index) => (
                                <div className={"marginTop-24"} key={index}>
                                    <Card
                                        heading={step.heading}
                                        subHeading={step.subHeading}
                                        imageUrl={step.imageUrl}
                                        ctaLabel={step.ctaLabel}
                                        iconUrl={step.iconUrl}
                                        index={index}
                                    />
                                </div>
                            ))}
                    </div>
                    <div className="marginTop-24">
                        {errMsg && <span className={`smallRegular marginBoth-4 errorColor `}>{errMsg}</span>}
                        <Button
                            label={!iconUrl ? mergeAccountInformation?.ctaLabel : null}
                            iconUrl={iconUrl}
                            isDisabled={iconUrl ? true : false}
                            onClick={tokenMerge}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    )
}

MergeAccount.propTypes = {
    forwardHandler: PropTypes.func.isRequired,
    state: PropTypes.shape({
        info: PropTypes.shape({
            email: PropTypes.string,
            phone: PropTypes.string,
        }),
        mergeAccountInformation: PropTypes.shape({
            flag: PropTypes.bool,
            header: PropTypes.string,
            description: PropTypes.string,
            imageUrl: PropTypes.string,
            imageAlt: PropTypes.string,
            heading: PropTypes.string,
            steps: PropTypes.array,
            ctaLabel: PropTypes.string,
        }),
    }).isRequired,
    localDispatch: PropTypes.func.isRequired,
}
Card.propTypes = {
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    ctaAction: PropTypes.func,
    ctaLabel: PropTypes.string,
    iconUrl: PropTypes.string,
    index: PropTypes.number,
}
export default MergeAccount
